import React, { Component } from 'react'
import { compose, Query } from 'react-apollo'
import { Form, Modal, Button, Spin } from 'antd'
// import _get from 'lodash/get'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'
import Script from 'react-load-script'
// import _get from 'lodash/get'
// import CardReactFormContainer from 'card-react'
import creditcardBrands from '~/assets/creditcard_brands.png'
import '~/lib/css/card.css'
import userCardsQuery from '~/App/graphql/queries/userCards.gql'
import CardInput from './CardInput';

// const radioStyle = {
//   display: 'block',
//   padding: '6px 0'
//   // height: '30px',
//   // lineHeight: '30px',
// }
@injectIntl
@Form.create()
class OmiseModal extends Component {
  state = {
    omiseLoaded: false
  }
  handleOmiseLoaded = () => {
    this.setState({
      omiseLoaded: true
    })
  }
  handleSubmit = e => {
    e.preventDefault()
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(this.props.publicKey)
    // e.preventDefault()
    this.props.form.validateFields(async (err, data) => {
      const { cardId, newCard, saveCard } = data
      if (cardId === 'new') {
        const { number, name, expiry, cvc } = newCard
        const [mm = '', yy = ''] = expiry.replace(/\s/g, '').split('/')
        const expirationMonth = mm
        const expirationYear = `20${yy.substr(-2)}`
        const cardData = {
          name: name.trim(),
          number: number.replace(/\s/g, ''),
          expiration_year: expirationYear, // eslint-disable-line camelcase
          expiration_month: expirationMonth, // eslint-disable-line camelcase
          security_code: cvc.replace(/\s/g, '') // eslint-disable-line camelcase
        }
        const token = await new Promise((resolve, reject) => {
          // eslint-disable-next-line no-undef
          Omise.createToken('card', cardData, (statusCode, response) => {
            if (statusCode !== 200) {
              return reject(response.message)
            }
            return resolve(response)
          })
        })
        return this.props.onCheckout({ token: { id: token.id, saveCard, bin: cardData.number.slice(0, 6) } })
      }
      return this.props.onCheckout({ card: { id: cardId } })
    })
     
  }
  render () {
    const {
      amount,
      visible,
      onClose,
      form: { getFieldDecorator, getFieldValue }
    } = this.props
    // TODO: move omise logic near to project root (for easier config import too)

    // const handleChange = (e) => {
    //   const {id, value} = e.target
    //   this.setState({
    //     [id]: value
    //   })
    // }
    
    const newCardDecorator = getFieldDecorator('newCard')
    // const saveCardDecorator = getFieldDecorator('saveCard', {
    //   valuePropName: 'checked',
    //   initialValue: true,
    // })
    
    return (

      <Modal visible={visible} footer={null} width={400} onCancel={onClose}>
        <Script
          url="https://cdn.omise.co/omise.js.gz"
          onLoad={this.handleOmiseLoaded}
          onError={() => console.error('error loading omise')}
        />
        {this.state.omiseLoaded ? 
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Query query={userCardsQuery} fetchPolicy="network-only">
              {({ data, loading }) => {
                if (loading) return <div className="modLoadding">
                  <Spin tip="Loading..." size="large" />
                </div>
                if (!data) return <div>Data not found</div>
                // const defaultCardId = _get(data, 'currentUser.customer.default_card_id')
                // const cards = _get(data, 'currentUser.customer.cards.data', [])
                getFieldDecorator('cardId', {
                  initialValue: 'new'
                })
                const cardId = getFieldValue('cardId')
                // const cardId = 'new'
                return <React.Fragment>
                  {/* {cardIdDecorator(
                    <Radio.Group>
                      {cards.map(card =>
                        <Radio style={radioStyle} key={card.id} value={card.id} ><strong>{card.brand}  ****{card.last_digits}</strong> {card.name}</Radio>
                      )}
                      <Radio style={radioStyle} key="new" value="new"><FormattedMessage id="app.newCard" defaultMessage="New credit/debit card" /></Radio>
                    </Radio.Group>
                  )} */}
                  {cardId === 'new' && newCardDecorator(<CardInput />)}
                  {/* {cardId === 'new' && saveCardDecorator(<Checkbox><FormattedMessage id="app.saveCard" defaultMessage="Remember this card" /></Checkbox>)} */}
                  <div className="submitBlock">
                    <Button htmlType="submit" icon="lock" loading={loading} type="primary">
                      <FormattedMessage id="app.payRequest.amount" values={{ amount: <FormattedNumber value={amount} /> }} />
                    </Button>
                  </div>
                  <div className="creditcardBrands">
                    <img src={creditcardBrands} alt="" />
                  </div>
                </React.Fragment>
              }}
            </Query>
          </Form>
          : <div className="modLoadding">
            <Spin tip="Loading..." size="large" />
          </div>}
      </Modal>
    )
  }
}

export default compose(Form.create())(OmiseModal)


  // < div id = "card-wrapper" ></div >
  //   <CardReactFormContainer
  //     // the id of the container element where you want to render the card element.
  //     // the card component can be rendered anywhere (doesn't have to be in ReactCardFormContainer).
  //     container="card-wrapper" // required

  //     // an object contain the form inputs names.
  //     // every input must have a unique name prop.
  //     formInputsNames={
  //       {
  //         number: 'CCnumber', // optional — default "number"
  //         expiry: 'CCexpiry', // optional — default "expiry"
  //         cvc: 'CCcvc', // optional — default "cvc"
  //         name: 'CCname' // optional - default "name"
  //       }
  //     }

  //     // initial values to render in the card element
  //     initialValues={
  //       {
  //         number: '', // optional — default •••• •••• •••• ••••
  //         cvc: '', // optional — default •••
  //         expiry: '', // optional — default ••/••
  //         name: '' // optional — default FULL NAME
  //       }
  //     }

  //     // the class name attribute to add to the input field and the corresponding part of the card element,
  //     // when the input is valid/invalid.
  //     classes={
  //       {
  //         valid: 'valid-input', // optional — default 'jp-card-valid'
  //         invalid: 'invalid-input' // optional — default 'jp-card-invalid'
  //       }
  //     }

  //     // specify whether you want to format the form inputs or not
  //     formatting={true} // optional - default true
  //   >
  //     <Form onSubmit={handleOnSubmit} layout="vertical">
  //       <div className="block">
  //         <Input placeholder={this.props.intl.formatMessage({ id: 'app.cardNumber' })} name="CCnumber" id="number" onChange={handleChange} required />
  //         <Input placeholder={this.props.intl.formatMessage({ id: 'app.nameOnCard' })} name="CCname" id="name" onChange={handleChange} required />
  //         <Input.Group compact>
  //           <Input placeholder={this.props.intl.formatMessage({ id: 'app.expirationDate' })} name="CCexpiry" id="expiration" onChange={handleChange} required />
  //           <Input placeholder={this.props.intl.formatMessage({ id: 'app.securityCode' })} id="security_code" name="CCcvc" className="ant-input" onChange={handleChange} required type="number" pattern="\d*" />
  //         </Input.Group>
  //       </div>
  //       <div className="submitBlock">
  //         <Button htmlType="submit" icon="lock" loading={loading} type="primary">
  //           <FormattedMessage id="app.payRequest.amount" values={{ amount }} />
  //         </Button>
  //       </div>
  //     </Form>
  //     <div className="creditcardBrands">
  //       <img src={creditcardBrands} alt="" />
  //     </div>
  //   </CardReactFormContainer>


// WEBPACK FOOTER //
// ./src/App/components/OmiseModal.js